import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import {
	LucideAngularModule,
	Ban,
	Binoculars,
	BookCheck,
	Building,
	ChartColumn,
	ChevronDown,
	ChevronRight,
	ChevronUp,
	CircleCheck,
	CircleQuestionMark,
	ClipboardCheck,
	ClipboardList,
	Database,
	EllipsisVertical,
	Eye,
	FileCheck,
	FilePen,
	FileText,
	FileUp,
	FileWarning,
	FolderDown,
	Globe,
	GraduationCap,
	Image,
	Import,
	Lock,
	LogOut,
	Mail,
	MapPin,
	MapPinCheck,
	Menu,
	MessageCircleMore,
	Pencil,
	Phone,
	Plus,
	Route,
	Search,
	SearchCheck,
	Settings,
	Shield,
	Ship,
	Truck,
	User,
	UserCog,
	UserLock,
	Warehouse,
	Wrench,
	X,
	Trash,
	ChevronLeft
} from 'lucide-angular';

export const provideLucideIcons = (): EnvironmentProviders => {
	return importProvidersFrom(
		LucideAngularModule.pick({
			Ban,
			Binoculars,
			BookCheck,
			Building,
			ChartColumn,
			ChevronDown,
			ChevronLeft,
			ChevronRight,
			ChevronUp,
			CircleCheck,
			CircleQuestionMark,
			ClipboardCheck,
			ClipboardList,
			Database,
			EllipsisVertical,
			Eye,
			FileCheck,
			FilePen,
			FileText,
			FileUp,
			FileWarning,
			FolderDown,
			Globe,
			GraduationCap,
			Image,
			Import,
			Lock,
			LogOut,
			Mail,
			MapPin,
			MapPinCheck,
			Menu,
			MessageCircleMore,
			Pencil,
			Phone,
			Plus,
			Route,
			Search,
			SearchCheck,
			Settings,
			Shield,
			Ship,
			Trash,
			Truck,
			User,
			UserCog,
			UserLock,
			Warehouse,
			Wrench,
			X
		})
	);
};
